import React from 'react';
import { Box } from '@metarouter-private/mr-mui';

import FeatureGate from 'app/launch-darkly/gates/feature-gate';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import TestPipelineDrawerContextProvider from './TestPipelineDrawerContextProvider';
import TestPipelineDrawer from './TestPipelineDrawer';
import StatusTable from './StatusTable';
import StatusTableWithTags from './StatusTableWithTags';

// Box with sx is required here — TestPipelineDrawerContextProvider breaks the
// direct parent-child relationship, so the parent's MuiPaper-root selector
// doesn't reach through. This inner Box re-targets the child Paper for height.
const TABLE_CONTAINER_STYLES = {
  height: '100%',
  '& > .MuiPaper-root': {
    height: '100%',
  },
};

export default function StatusItem() {
  return (
    <TestPipelineDrawerContextProvider>
      <TestPipelineDrawer />
      <Box sx={TABLE_CONTAINER_STYLES}>
        <FeatureGate flagName={FEATURE_FLAGS.pipelineTagsMvp} fallback={<StatusTable />}>
          <StatusTableWithTags />
        </FeatureGate>
      </Box>
    </TestPipelineDrawerContextProvider>
  );
}
